/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 89399:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Link = __webpack_require__(70937);
var _require = __webpack_require__(94346),
  getLinkProps = _require.getLinkProps;
module.exports = Link;
module.exports.getLinkProps = getLinkProps;

/***/ }),

/***/ 95699:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _objectSpread = (__webpack_require__(91903)["default"]);
var _classCallCheck = (__webpack_require__(77537)["default"]);
var _createClass = (__webpack_require__(68765)["default"]);
__webpack_require__(33114);
/* eslint-disable max-params */
var Tracking = /*#__PURE__*/function () {
  "use strict";

  function Tracking() {
    _classCallCheck(this, Tracking);
  }
  return _createClass(Tracking, null, [{
    key: "getComponentTrackingLabel",
    value: function getComponentTrackingLabel() {
      var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var normalizedLabel = arguments.length > 2 ? arguments[2] : undefined;
      return "".concat(component, "_").concat(position + 1, "_").concat(normalizedLabel).toUpperCase();
    }
  }, {
    key: "setMelidataTracking",
    value: function setMelidataTracking(linkData, trackingData, analytics) {
      var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var folder = arguments.length > 4 ? arguments[4] : undefined;
      var event_data = arguments.length > 5 ? arguments[5] : undefined;
      var trackingMD = arguments.length > 6 ? arguments[6] : undefined;
      var component = linkData.component,
        position = linkData.position,
        isMyCoins = linkData.isMyCoins,
        isQuotes = linkData.isQuotes;
      if (trackingData && typeof melidata === 'function') {
        var dynamicInfo = trackingMD.dynamicInfo,
          context = trackingMD.context;
        var _module = dynamicInfo.module,
          group = dynamicInfo.group,
          content = dynamicInfo.content;
        var category = 'LANDINGS';
        var formattedLabel = this.getComponentTrackingLabel(component, position, label);
        var melidataData = trackingData.melidata;
        var isCategory = folder === 'c';
        var data = {
          category: category.toLowerCase(),
          action: analytics,
          label: formattedLabel.toLowerCase(),
          module: _module,
          group: group,
          content: content,
          context: context
        };
        if (event_data) data = _objectSpread(_objectSpread({}, data), event_data);

        /**
         * Category event track
         */
        if (isCategory) {
          return melidata('send', 'event', {
            path: melidataData.categories.event,
            data: data
          });
        }
        /**
         * MeliCoin landing events tracks
         */
        if (isMyCoins) {
          return melidata('send', 'event', {
            path: "".concat(melidataData.melicoins, "/crypto"),
            data: {
              category: 'ucrania',
              action: 'go_to_mp_mycoins'
            }
          });
        }
        if (isQuotes) {
          return melidata('send', 'event', {
            path: "".concat(melidataData.melicoins, "/crypto"),
            data: {
              category: 'ucrania',
              action: 'go_to_mp_quotes'
            }
          });
        }

        /**
         * Default event track
         */
        return melidata('send', 'event', {
          path: "".concat(melidataData.deals, "/event"),
          data: data
        });
      }
    }
  }, {
    key: "sendMeliGATracking",
    value: function sendMeliGATracking(linkData, analytics) {
      var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (typeof meli_ga === 'function') {
        var category = 'LANDINGS';
        var component = linkData.component,
          position = linkData.position,
          _linkData$isMyCoins = linkData.isMyCoins,
          isMyCoins = _linkData$isMyCoins === void 0 ? false : _linkData$isMyCoins,
          _linkData$isQuotes = linkData.isQuotes,
          isQuotes = _linkData$isQuotes === void 0 ? false : _linkData$isQuotes;
        var action = analytics.toUpperCase();
        var formattedLabel = this.getComponentTrackingLabel(component, position, label);

        /**
         * MeliCoin landing events tracks
         */
        if (isMyCoins) {
          return meli_ga('send', 'event', 'CRYPTO', 'GO_TO_MP_MYCOINS');
        }
        if (isQuotes) {
          return meli_ga('send', 'event', 'CRYPTO', 'GO_TO_MP_QUOTES');
        }

        /**
         * Default event track
         */
        return meli_ga('send', 'event', category, action, formattedLabel);
      }
    }
  }]);
}();
module.exports = Tracking;

/***/ }),

/***/ 70937:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
var _jsx = (__webpack_require__(90029)["default"]);
__webpack_require__(57037);
var React = __webpack_require__(16689);
var _require = __webpack_require__(23708),
  VisuallyHidden = _require.VisuallyHidden;
var _require2 = __webpack_require__(31901),
  LandingContext = _require2.LandingContext;
var _require3 = __webpack_require__(94346),
  getLinkProps = _require3.getLinkProps;
var LinkComponent = function LinkComponent(props) {
  var link = props.link,
    label = props.label,
    text = props.text,
    children = props.children,
    styles = props.styles,
    customClass = props.customClass,
    customDivClass = props.customDivClass,
    element_order = props.element_order,
    event_data = props.event_data,
    visuallyHidden = props.visuallyHidden;
  var _React$useContext = React.useContext(LandingContext),
    landingConfig = _React$useContext.landingConfig,
    trackingData = _React$useContext.trackingData,
    uuid = _React$useContext.uuid,
    supportNewPdp = _React$useContext.supportNewPdp,
    trackingMD = _React$useContext.trackingMD,
    nativeAppName = _React$useContext.nativeAppName;
  if (!link || !link.url) {
    return children && /*#__PURE__*/_jsx("div", {
      className: customDivClass
    }, void 0, children);
  }
  return /*#__PURE__*/_reactJsxRuntime.jsxs("a", _objectSpread(_objectSpread({
    style: styles,
    className: "splinter-link".concat(customClass ? " ".concat(customClass) : '')
  }, getLinkProps({
    nativeAppName: nativeAppName,
    link: link,
    label: label,
    element_order: element_order,
    event_data: event_data,
    landingConfig: landingConfig,
    trackingData: trackingData,
    uuid: uuid,
    supportNewPdp: supportNewPdp,
    trackingMD: trackingMD
  })), {}, {
    children: [text, visuallyHidden && /*#__PURE__*/_jsx(VisuallyHidden, {}, void 0, visuallyHidden), children && /*#__PURE__*/_jsx("div", {
      className: customDivClass
    }, void 0, children)]
  }));
};
LinkComponent.defaultProps = {
  text: null,
  children: null,
  styles: null,
  customClass: null,
  customDivClass: null,
  event_data: null
};
module.exports = LinkComponent;

/***/ }),

/***/ 80539:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _slicedToArray = (__webpack_require__(90353)["default"]);
var _classCallCheck = (__webpack_require__(77537)["default"]);
var _createClass = (__webpack_require__(68765)["default"]);
__webpack_require__(33114);
__webpack_require__(63600);
__webpack_require__(91689);
__webpack_require__(68795);
__webpack_require__(3524);
__webpack_require__(92448);
__webpack_require__(96770);
__webpack_require__(63317);
__webpack_require__(59344);
var Parse = __webpack_require__(13883);
var _require = __webpack_require__(96104),
  loyaltyParams = _require.loyaltyParams,
  _require$visCategoryI = _require.visCategoryId,
  inmuebles = _require$visCategoryI.inmuebles,
  motors = _require$visCategoryI.motors;
var LinkParser = /*#__PURE__*/function () {
  "use strict";

  function LinkParser() {
    _classCallCheck(this, LinkParser);
  }
  return _createClass(LinkParser, null, [{
    key: "decomposer",
    value:
    /**
     * Method for decompose links, in order of obtain diferents parts of links.
     *
     * @param {String} url
     * @returns {Object}
     * @memberof LinkParser
     */
    function decomposer(url) {
      var parsedURL = new Parse(url, true);
      return {
        url: parsedURL.href,
        protocol: parsedURL.protocol,
        domain: parsedURL.host,
        path: parsedURL.pathname,
        hash: parsedURL.hash,
        subdomain: parsedURL.host.split('.')[0],
        queryParams: parsedURL.query
      };
    }

    /**
     * Internal class method to check if the url has query params.
     *
     * @param {Object} decomposedURL - Decomposed URL to check query params
     * @returns {Boolean}
     * @memberof LinkParser
     */
  }, {
    key: "hasQueryParams",
    value: function hasQueryParams(decomposedURL) {
      return decomposedURL.queryParams && JSON.stringify(decomposedURL.queryParams) !== '{}';
    }

    /**
     * Method for convert links to deeplinks.
     * When recive param forcedGeneric true exception, should return webview deeplink.
     *
     * @param {String} url
     * @param {String} siteId
     * @param {boolean} forcedGeneric
     * @returns {String}
     * @memberof LinkParser
     */
    // eslint-disable-next-line max-params
  }, {
    key: "convertToDeeplink",
    value: function convertToDeeplink(url, siteId) {
      var forcedGeneric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var hidePsmb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var supportNewPdp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var nativeAppName = arguments.length > 6 ? arguments[6] : undefined;
      var isBottomSheet = arguments.length > 7 ? arguments[7] : undefined;
      var allowBottomSheet = arguments.length > 8 ? arguments[8] : undefined;
      var deepLinkWebView = 'meli://webview/?url=';
      var deepLinkMP = 'mercadopago://webview?url=';
      var deepLinkVIP = 'meli://item?id=';
      var deepLinkVIPNew = 'meli://items-core/';
      var deepLinkDefault = 'meli://search?go=';
      var deepLinkExternal = nativeAppName === 'MercadoPago' ? 'mercadopago://browser?url=' : 'meli://browser?url=';
      var deepLinkLoyalty = 'meli://loyalty';
      var deepLinkCategories = 'meli://search?category=';
      var deepLinkPdpOrUp = 'meli://products/';
      var deepLinkCredits = 'meli://credits-opensea/?sk=JckK2t3Y';
      var deepLinkVIS = 'meli://sell/goal/list';
      var deepLinkVISCX = 'meli://cx/help?url=';
      var deepLinkLive = 'meli://live/';
      var deepLinkBottomsheet = 'meli://webview/bottomsheet?url=';
      var deepLinkBottomsheetMP = 'mercadopago://webview/bottomsheet?url=';
      var decomposedURL = this.decomposer(url);
      var URLtoResponse = url;
      var externalRegex = /((w{3}\.)|\w)+[.]+(mercadolibre|mercadolivre|mercadopago)/g;
      var ideasJobsRegex = /(jobs|ideas)+[.]+(mercadolibre)/g;
      var cxRegex = /(ayuda|ajuda|help)/g;
      var deeplinkMPRegex = /(mercadopago)+[:]/g;
      var isExternalLink = !externalRegex.test(decomposedURL.domain) && !decomposedURL.domain.includes('go.onelink') && !deeplinkMPRegex.test(decomposedURL.url);
      var isLoyalty = decomposedURL.path.match(/\/mercado-puntos$/);
      var isIdeasOrJobsLink = ideasJobsRegex.test(decomposedURL.domain);
      var isLoyaltyMLB = decomposedURL.path.match(/\/mercado-pontos$/);
      var isPdp = decomposedURL.path.match(/\/p\//);
      var isUp = decomposedURL.path.match(/\/up\//);
      var isVIS = decomposedURL.path.includes('sell/sell');
      var isVISHub = decomposedURL.path.includes('publicar/hub');
      var isVISCX = cxRegex.test(decomposedURL.path);
      var isMPDeepLink = url.includes('mercadopago:');
      var isMPLink = decomposedURL.domain.includes('mercadopago');
      var isLiveLink = decomposedURL.path.includes('/live/');
      var isEncuestasLink = decomposedURL.domain.includes('encuestas');
      var isCredits = decomposedURL.queryParams && decomposedURL.queryParams.sk && decomposedURL.queryParams.sk.match(/zfhkYo5V/);
      var isHubLink = decomposedURL.subdomain === 'www' && !isExternalLink && !isLoyalty && !isLoyaltyMLB && !isPdp && !isUp && !isCredits && !isVIS && !isVISHub && !isVISCX && !isLiveLink;
      if (isBottomSheet && allowBottomSheet) {
        URLtoResponse = this.parseParams(decomposedURL);
        var deepLinkBase = isMPLink ? deepLinkBottomsheetMP : deepLinkBottomsheet;
        return "".concat(deepLinkBase).concat(URLtoResponse.url, "&show_drag_indicator=false&close_button_mode=inner");
      }
      if (isMPLink) {
        URLtoResponse = this.parseParams(decomposedURL);
        return "".concat(deepLinkMP).concat(URLtoResponse.url);
      }
      if (isHubLink || forcedGeneric) {
        URLtoResponse = this.parseParams(decomposedURL);
        return "".concat(deepLinkWebView).concat(URLtoResponse.url);
      }
      if (isEncuestasLink) {
        URLtoResponse = this.parseParams(decomposedURL);
        return "".concat(deepLinkWebView).concat(URLtoResponse.url, "&back_action=close&back_style=cross&bar_left_button_style=close");
      }
      if (decomposedURL.path.includes(siteId) && !isPdp && !isUp) {
        var itemID = decomposedURL.path.split('-')[1];
        if (hidePsmb) {
          return "".concat(deepLinkVIP).concat(siteId).concat(itemID, "&hide_psmb=true").concat(params.replace('?', '&'));
        }
        if (supportNewPdp) {
          return "".concat(deepLinkVIPNew).concat(siteId).concat(itemID, "/").concat(params);
        }
        return "".concat(deepLinkVIP).concat(siteId).concat(itemID).concat(params);
      }
      if (isExternalLink || isIdeasOrJobsLink) {
        URLtoResponse = this.parseParams(decomposedURL);
        return "".concat(deepLinkExternal).concat(URLtoResponse.url);
      }
      if (isLoyalty || isLoyaltyMLB) {
        var urlEncoded = this.parseParams(decomposedURL);
        if (isLoyaltyMLB) {
          return "".concat(deepLinkLoyalty, "/webview?url=").concat(urlEncoded.url).concat(loyaltyParams.MLB);
        }
        if (isLoyalty && decomposedURL.domain.includes('.com.ar')) {
          return "".concat(deepLinkLoyalty, "/webview?url=").concat(urlEncoded.url).concat(loyaltyParams.MLA);
        }
        return "".concat(deepLinkLoyalty).concat(params);
      }
      if (decomposedURL.hash.includes('CATEGORY_ID')) {
        var _decomposedURL$hash$s = decomposedURL.hash.split('&'),
          _decomposedURL$hash$s2 = _slicedToArray(_decomposedURL$hash$s, 1),
          hashCategoryID = _decomposedURL$hash$s2[0];
        var _hashCategoryID$split = hashCategoryID.split('='),
          _hashCategoryID$split2 = _slicedToArray(_hashCategoryID$split, 2),
          categoryID = _hashCategoryID$split2[1];
        return "".concat(deepLinkCategories).concat(categoryID).concat(params);
      }
      if (isUp || isPdp) {
        var _ref = isUp ? decomposedURL.path.split('/up/') : decomposedURL.path.split('/p/'),
          _ref2 = _slicedToArray(_ref, 2),
          itemId = _ref2[1];
        if (decomposedURL.queryParams.pdp_filters) {
          return "".concat(deepLinkPdpOrUp).concat(itemId, "/?pdp_filters=").concat(encodeURI(decomposedURL.queryParams.pdp_filters)).concat(params);
        }
        return "".concat(deepLinkPdpOrUp).concat(itemId, "/").concat(params);
      }
      if (isCredits) {
        return "".concat(deepLinkCredits).concat(params);
      }
      if (isVIS || isVISHub) {
        var categoryId = decomposedURL.queryParams.category;
        if (inmuebles.includes(categoryId)) {
          return "".concat(deepLinkVIS).concat(params);
        }
        if (motors.includes(categoryId)) {
          return "".concat(deepLinkVIS, "?vertical=motors").concat(params.replace('?', '&'));
        }
        return "".concat(deepLinkVIS).concat(params);
      }
      if (isVISCX) {
        var _urlEncoded = this.parseParams(decomposedURL);
        return "".concat(deepLinkVISCX).concat(_urlEncoded.url);
      }
      if (isLiveLink) {
        return "".concat(deepLinkLive).concat(decomposedURL.path.split('live/')[1]);
      }
      if (isMPDeepLink) {
        return "".concat(decomposedURL.url);
      }
      var _URLtoResponse$split = URLtoResponse.split('#'),
        _URLtoResponse$split2 = _slicedToArray(_URLtoResponse$split, 2),
        fragment = _URLtoResponse$split2[1];
      URLtoResponse = this.parseParams(decomposedURL, false);
      return "".concat(deepLinkDefault).concat(URLtoResponse.url).concat(fragment ? "#".concat(fragment) : '');
    }

    /**
     * Method for parse params and hash of URLs
     *
     * @param {Object} descomposedURL
     * @returns {Object}
     * @memberof LinkParser
     */
  }, {
    key: "parseParams",
    value: function parseParams(descomposedURL) {
      var addFragment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _descomposedURL$url$s = descomposedURL.url.split('#'),
        _descomposedURL$url$s2 = _slicedToArray(_descomposedURL$url$s, 2),
        urlToEncode = _descomposedURL$url$s2[0],
        fragment = _descomposedURL$url$s2[1];
      var encodedUrl = encodeURIComponent(urlToEncode).replace('*', '%2A');
      var encodedFragment = fragment && addFragment ? encodeURIComponent("#".concat(fragment)) : '';
      descomposedURL.url = "".concat(encodedUrl).concat(encodedFragment);
      return descomposedURL;
    }
  }]);
}();
module.exports = LinkParser;

/***/ }),

/***/ 96104:
/***/ ((module) => {

/* eslint-disable max-len */

var loyaltyParams = {
  MLB: '&title=Mercado%20Pontos&use_web_title=false&back_style=menu&back_action=close&swipe_gesture=true&authenticate=true&loading_mode=none',
  MLA: '&title=Mercado%20Puntos&use_web_title=false&back_style=menu&back_action=close&swipe_gesture=true&authenticate=true&loading_mode=none'
};
var visCategoryId = {
  inmuebles: ['MLA1459', 'MLM1459', 'MLB1459', 'MCO1459', 'MLC1459', 'MLU1459', 'MPE1459', 'MLV1459'],
  motors: ['MLA1743', 'MLM1743', 'MLB1743', 'MCO1743', 'MLC1743', 'MLU1743', 'MPE1743', 'MLV1743']
};
module.exports = {
  loyaltyParams: loyaltyParams,
  visCategoryId: visCategoryId
};

/***/ }),

/***/ 94346:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _objectSpread = (__webpack_require__(91903)["default"]);
var _slicedToArray = (__webpack_require__(90353)["default"]);
__webpack_require__(33114);
__webpack_require__(86486);
__webpack_require__(63600);
__webpack_require__(81624);
__webpack_require__(40887);
__webpack_require__(61000);
__webpack_require__(3524);
__webpack_require__(92448);
__webpack_require__(58719);
__webpack_require__(21074);
__webpack_require__(83940);
__webpack_require__(75352);
__webpack_require__(63792);
__webpack_require__(20629);
__webpack_require__(23009);
__webpack_require__(92281);
__webpack_require__(96770);
__webpack_require__(72047);
__webpack_require__(59344);
__webpack_require__(57037);
__webpack_require__(38534);
/* eslint-disable max-params */
/* eslint-disable no-unused-vars */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */

var LinkParser = __webpack_require__(80539);
var Tracking = __webpack_require__(95699);

/**
 * Add Params to URL (query params, fragments, etc)
 * @param {object} params
 * @returns {string}
 */
function getParams(_ref) {
  var link = _ref.link,
    source = _ref.source,
    label = _ref.label,
    showDealParam = _ref.showDealParam,
    uuid = _ref.uuid,
    webView = _ref.webView,
    modelVersion = _ref.modelVersion,
    promotionType = _ref.promotionType,
    element_order = _ref.element_order,
    allowBottomSheet = _ref.allowBottomSheet;
  var concatShowDeal = link.url.includes('?') ? '&showDeal=true' : '?showDeal=true';
  var showDeal = showDealParam && link.component && !link.component.toLowerCase().includes('carouseldynamic') ? concatShowDeal : '';
  var sanitizeLabel = label.replace('%', '');
  var showDealId = link.deal_id ? "#DEAL_ID=".concat(link.deal_id, "&S=").concat(source, "&V=").concat(link.position, "&T=").concat(link.component, "&L=").concat(encodeURI(sanitizeLabel)) : "#S=".concat(source, "&V=").concat(link.position, "&T=").concat(link.component, "&L=").concat(encodeURI(sanitizeLabel));

  // If showDealParam exists it already checked for ? en the url and it's going to concat a ? if it didn't exist.
  var concatBottomSheet = showDealParam || link.url.includes('?') ? '&isBottomSheet=true' : '?isBottomSheet=true';

  // if the link has bottomSheet and i'm not already in a bottomSheet view, concat the param.
  var showBottomsheet = link.isBottomSheet && allowBottomSheet ? concatBottomSheet : '';
  var urlHasFragment = link && link.url && /#/.test(link.url);
  var model_version = modelVersion ? "&model_version=".concat(modelVersion) : '';
  var promotion_type = promotionType ? "&promotion_type=".concat(promotionType) : '';
  var fragment = link.url ? "".concat(link.url.split('#').pop()) : '';
  if (uuid && !link.categoryId) {
    if (link.deal_id) {
      if (urlHasFragment) {
        return "".concat(showDeal).concat(showBottomsheet, "#").concat(fragment, "&DEAL_ID=").concat(link.deal_id, "&S=").concat(source, "&V=").concat(link.position, "&T=").concat(link.component, "&L=").concat(encodeURI(sanitizeLabel), "&deal_print_id=").concat(uuid, "&c_tracking_id=").concat(uuid);
      }
      return "".concat(showDeal).concat(showBottomsheet).concat(showDealId, "&deal_print_id=").concat(uuid, "&c_tracking_id=").concat(uuid);
    }
    if (urlHasFragment) {
      return "".concat(showDeal).concat(showBottomsheet, "#").concat(fragment, "&deal_print_id=").concat(uuid).concat(model_version).concat(promotion_type, "&c_tracking_id=").concat(uuid);
    }
    return "".concat(showDeal).concat(showBottomsheet, "#deal_print_id=").concat(uuid).concat(model_version).concat(promotion_type, "&c_tracking_id=").concat(uuid);
  }
  if (link.categoryId) {
    if (urlHasFragment) {
      return "".concat(showDeal).concat(showBottomsheet, "#").concat(fragment, "&CATEGORY_ID=").concat(link.categoryId, "&S=").concat(source, "&c_tracking_id=").concat(uuid);
    }
    return "".concat(showDeal).concat(showBottomsheet, "#CATEGORY_ID=").concat(link.categoryId, "&S=").concat(source, "&c_tracking_id=").concat(uuid);
  }
  if (urlHasFragment) {
    return "".concat(showDeal).concat(showBottomsheet).concat(showDealId).concat(fragment, "&c_tracking_id=").concat(uuid);
  }
  return "".concat(showDeal).concat(showBottomsheet).concat(showDealId, "&c_tracking_id=").concat(uuid);
}

/**
 * Method to normalize any string
 * Unicode Normalization Form of a given string, polyfill if not exists method via browser...
 * @param {string}
 * @returns {string}
 */
function normalize(str) {
  if (typeof String.prototype.normalize === 'function') {
    return str.normalize('NFD');
  }
  var lowerCaseStr = str.toLowerCase();
  var non_asciis = {
    a: /[àáâãäå]/g,
    ae: /æ/g,
    c: /ç/g,
    e: /[èéêë]/g,
    i: /[ìíîï]/g,
    n: /ñ/g,
    o: /[òóôõö]/g,
    oe: /œ/g,
    u: /[ùúûűü]/g,
    y: /[ýÿ]/g
  };
  for (var i in non_asciis) {
    lowerCaseStr = lowerCaseStr.replace(non_asciis[i], i);
  }
  return lowerCaseStr;
}
function normalizeComponentLabel(label) {
  return normalize(label || '').replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '-').toUpperCase();
}
var sendTracks = function sendTracks(link, trackingData, analytics, label, folder, event_data, trackingMD) {
  Tracking.sendMeliGATracking(link, analytics, label);
  Tracking.setMelidataTracking(link, trackingData, analytics, label, folder, event_data, trackingMD);
};
var handleOnClick = function handleOnClick(webView, isBottomSheetParam, href, link, trackingData, analytics, labelNormalized, folder, event_data, trackingMD) {
  sendTracks(link, trackingData, analytics, labelNormalized, folder, event_data, trackingMD);
  if (webView && isBottomSheetParam) {
    MobileWebKit.bottomSheet.navigation.navigate({
      deeplink: href,
      close: true
    });
  }
};
var getLinkProps = function getLinkProps(_ref2) {
  var nativeAppName = _ref2.nativeAppName,
    link = _ref2.link,
    label = _ref2.label,
    element_order = _ref2.element_order,
    event_data = _ref2.event_data,
    landingConfig = _ref2.landingConfig,
    trackingData = _ref2.trackingData,
    _ref2$uuid = _ref2.uuid,
    uuid = _ref2$uuid === void 0 ? null : _ref2$uuid,
    supportNewPdp = _ref2.supportNewPdp,
    trackingMD = _ref2.trackingMD;
  var onlyLink = link.onlyLink,
    modelVersion = link.modelVersion,
    promotionType = link.promotionType,
    dealPrintId = link.dealPrintId,
    _link$target = link.target,
    target = _link$target === void 0 ? '_self' : _link$target,
    _link$rel = link.rel,
    rel = _link$rel === void 0 ? '' : _link$rel,
    _link$hidePsmb = link.hidePsmb,
    hidePsmb = _link$hidePsmb === void 0 ? false : _link$hidePsmb,
    _link$noFollow = link.noFollow,
    noFollow = _link$noFollow === void 0 ? false : _link$noFollow,
    isBottomSheet = link.isBottomSheet;
  var analytics = landingConfig.analytics,
    webView = landingConfig.webView,
    siteId = landingConfig.siteId,
    showDealParam = landingConfig.showDealParam,
    isBottomSheetParam = landingConfig.isBottomSheetParam,
    folder = landingConfig.folder,
    osName = landingConfig.osName,
    isTakeover = landingConfig.isTakeover;
  var labelNormalized = normalizeComponentLabel(label);
  var source = "".concat(link.categoryId ? 'hc_' : 'landingHub').concat(analytics);
  var isTargetBlank = target === '_blank';
  var relAttrSet = new Set(rel ? rel.split(' ') : []);
  var allowBottomSheet = !isBottomSheetParam && (osName === 'ios' && !isTakeover || osName === 'android');
  if (isTargetBlank) {
    relAttrSet.add('noopener');
    relAttrSet.add('noreferrer');
  }
  if (noFollow) relAttrSet.add('nofollow');
  var relAttribute = Array.from(relAttrSet).join(' ');
  var params = getParams({
    link: link,
    source: source,
    label: labelNormalized,
    showDealParam: showDealParam,
    uuid: dealPrintId || uuid,
    webView: webView,
    modelVersion: modelVersion,
    promotionType: promotionType,
    element_order: element_order,
    allowBottomSheet: allowBottomSheet
  });
  var _link$url$split = link.url.split('#'),
    _link$url$split2 = _slicedToArray(_link$url$split, 1),
    urlBeforeFragment = _link$url$split2[0];
  var url = "".concat(urlBeforeFragment).concat(onlyLink ? '' : params);
  var handleHref = function handleHref() {
    if (webView && !link.isCustomDeeplink) {
      return LinkParser.convertToDeeplink(url, siteId, link.forcedGeneric || false, onlyLink ? '' : params, hidePsmb, supportNewPdp, nativeAppName, isBottomSheet, allowBottomSheet);
    }
    if (webView && link.isCustomDeeplink) {
      var customDeepLink = link.customDeeplink;
      var urlParams = params || '';
      if (urlParams) {
        if (customDeepLink.includes('?')) {
          urlParams = urlParams.replace('?', '&');
        }
      }
      if (customDeepLink.includes('#')) {
        var _customDeepLink$split = customDeepLink.split('#'),
          _customDeepLink$split2 = _slicedToArray(_customDeepLink$split, 2),
          baseUrl = _customDeepLink$split2[0],
          fragment = _customDeepLink$split2[1];
        return "".concat(baseUrl).concat(urlParams).concat(urlParams ? '&' : '#').concat(fragment);
      }
      return "".concat(customDeepLink).concat(urlParams);
    }
    return url;
  };
  var href = handleHref();
  return _objectSpread(_objectSpread(_objectSpread({}, !(webView && isBottomSheetParam) && {
    href: href
  }), {}, {
    target: target
  }, relAttribute && {
    rel: relAttribute
  }), {}, {
    onClick: function onClick() {
      return handleOnClick(webView, isBottomSheetParam, href, link, trackingData, analytics, labelNormalized, folder, event_data, trackingMD);
    }
  });
};
module.exports = {
  getLinkProps: getLinkProps,
  getParams: getParams,
  normalize: normalize,
  normalizeComponentLabel: normalizeComponentLabel
};

/***/ }),

/***/ 23708:
/***/ ((module) => {

"use strict";
module.exports = require("@andes/common");

/***/ }),

/***/ 77537:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 68765:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 90353:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 33114:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.concat.js");

/***/ }),

/***/ 86486:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.from.js");

/***/ }),

/***/ 63600:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.includes.js");

/***/ }),

/***/ 81624:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.iterator.js");

/***/ }),

/***/ 40887:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.join.js");

/***/ }),

/***/ 91689:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.date.to-json.js");

/***/ }),

/***/ 68795:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.json.stringify.js");

/***/ }),

/***/ 61000:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ 3524:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.exec.js");

/***/ }),

/***/ 92448:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.test.js");

/***/ }),

/***/ 21074:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.difference.v2.js");

/***/ }),

/***/ 83940:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.intersection.v2.js");

/***/ }),

/***/ 75352:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.is-disjoint-from.v2.js");

/***/ }),

/***/ 63792:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.is-subset-of.v2.js");

/***/ }),

/***/ 20629:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.is-superset-of.v2.js");

/***/ }),

/***/ 58719:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.js");

/***/ }),

/***/ 23009:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.symmetric-difference.v2.js");

/***/ }),

/***/ 92281:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.set.union.v2.js");

/***/ }),

/***/ 96770:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.includes.js");

/***/ }),

/***/ 72047:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.iterator.js");

/***/ }),

/***/ 57037:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.link.js");

/***/ }),

/***/ 63317:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.match.js");

/***/ }),

/***/ 59344:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.replace.js");

/***/ }),

/***/ 38534:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/web.dom-collections.iterator.js");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ }),

/***/ 13883:
/***/ ((module) => {

"use strict";
module.exports = require("url-parse");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(89399);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map